export enum ServiceUrgency {
    //LOW = "Low",
    MEDIUM = "Medium",
    //HIGH = "High",
}
